import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataService } from '../../data/data.service';
const url     = 'api/Languages';
const BaseUrl = environment.BaseUrl;

@Injectable({
  providedIn: 'root'
})
export class LanguageService extends DataService {

  constructor(http : HttpClient) { 
    super(url, BaseUrl, http, "");
  }
}
